import {
  lazy,
} from 'react';
const News = lazy(() => import('./page/news/index'));
const Short = lazy(() => import('./page/short'));
const NotFound = lazy(() => import('./page/notfound'));
const ThirdShare = lazy(() => import('./page/thirdShare'));
const HighShare = lazy(() => import('./page/highShare'));
const Video = lazy(() => import('./page/video'));
const BackNews = lazy(() => import('./page/backNews'));
const ShortContentPage = lazy(() => import('./page/shortContent'));
const Activity = lazy(() => import('./page/eCommerceFission/activityPage'));
const Commodity = lazy(() => import('./page/eCommerceFission/CommodityPage/index'));
const PCNews = lazy(() => import('./page/pcnews/index'));
const PCVideo = lazy(() => import('./page/pcvideo/index'));

const routes = [
  {
    path: '/v1/news/:id',
    component: News
  },
  {
    path: '/v2/news/:id',
    component: News
  },
  {
    path: '/v3/news/:id',
    component: News
  },
  {
    path: '/v1/short',
    component: Short
  },
  {
    path: '/v1/thirdShare',
    component: ThirdShare
  },
  {
    path: '/v2/highShare',
    component: HighShare
  },
  {
    path: '/v1/video/:id',
    component: Video
  },
  {
    path: '/v2/video/:id',
    component: Video
  },
  {
    path: '/v3/video/:id',
    component: Video
  },
  {
    path: '/v2/backNews',
    component: BackNews
  },
  {
    path: '/v2/shortContent',
    component: ShortContentPage
  },
  {
    path: '/v3/shortContent',
    component: ShortContentPage
  },
  {
    path: '/v2/activityList',
    component: Activity
  },
  {
    path: '/v2/activityCommodity',
    component: Commodity
  },
  {
    path: '/v3/activityList',
    component: Activity
  },
  {
    path: '/v3/activityCommodity',
    component: Commodity
  },
  {
    path: '/v4/activityList',
    component: Activity
  },
  {
    path: '/v4/activityCommodity',
    component: Commodity
  },
  {
    path: '/v5/activityList',
    component: Activity
  },
  {
    path: '/v5/activityCommodity',
    component: Commodity
  },
  {
    path: '/v6/activityList',
    component: Activity
  },
  {
    path: '/v6/activityCommodity',
    component: Commodity
  },
  {
    path: '/v7/activityList',
    component: Activity
  },
  {
    path: '/v7/activityCommodity',
    component: Commodity
  },
  // pc
  {
    path: '/pc/news/:id',
    component: PCNews
  },
  {
    path: '/pc/video/:id',
    component: PCVideo
  },
  // pc preview for test
  {
    path: '/v1/pc/news/:id',
    component: PCNews
  },
  {
    path: '/v1/pc/video/:id',
    component: PCVideo
  },
  {
    path: '*',
    component: NotFound
  }
];

export default routes
